import { __decorate } from "tslib";
import { html } from 'lit';
import { CipublicElement } from '@cigna/cigna_csg_gsg_cipublic-shared/lib/mixins/base.js';
import { state, property, query } from 'lit/decorators.js';
import { gridBreakpoints } from '@cigna/cigna_csg_gsg_cipublic-shared/lib/utils/breakpoints.js';
import { addStyleSheetToElements } from '@cigna/cigna_csg_gsg_cipublic-shared/lib/utils/cssstylesheet-interface.js';
import { InternalI18n } from '@cigna/cigna_csg_gsg_cipublic-shared/lib/i18n/internal-i18n-controller.js';
import { debounce } from '@cigna/cigna_csg_gsg_cipublic-shared/lib/utils/debounce.js';
import styles from './header.scss.js';
import navigationLinksStyles from './links.scss.js';
import sectionLinkHolderStyles from './section-link-holder.scss.js';
import mobileNavigationLinksStyles from './mobile-links.scss.js';
import mobileMenuLinksStyles from './mobile-menu-links.scss.js';
import mobileMenuToggleStyles from './mobile-menu-button.scss.js';
import dropdownHeadingStyles from './dropdown-heading.scss.js';
import dropdownSlotsStyles from './dropdown-slots.scss.js';
import headerRightMenuLinksHolderStyles from './header-links.scss.js';
import headerLeftMenuStyles from './left-header.scss.js';
import headerLeftMenuLinksStyles from './left-header-links.scss.js';
import headerRightMenuLinksStyles from './right-header-links.scss.js';
import headerContentBlockStyles from './header-content-blocks.scss.js';
import headerLogoLinkStyles from './header-logo-link.scss.js';
import headerLogoStyles from './header-logo.scss.js';
import listStyles from './list.scss.js';
import '@cigna/cigna_csg_gsg_cipublic-backdrop/cipublic-backdrop.js';
import '@cigna/cigna_csg_gsg_cipublic-close-button/cipublic-close-button.js';
import '@cigna/cigna_csg_gsg_cipublic-language-toggle/cipublic-language-toggle.js';
import '@cigna/cigna_csg_gsg_cipublic-link/cipublic-link.js';
import '@cigna/cigna_csg_gsg_cipublic-icon/cipublic-icon.js';
import '@cigna/cigna_csg_gsg_cipublic-focus-trap/cipublic-focus-trap.js';
import '@cigna/cigna_csg_gsg_cipublic-accordion/cipublic-accordion.js';
import '@cigna/cigna_csg_gsg_cipublic-header-search/cipublic-header-search.js';
// import '@cigna/cigna_csg_gsg_cipublic-modal/cipublic-modal.js';
import '@cigna/cigna_csg_gsg_cipublic-list/cipublic-list.js';
import '@cigna/cigna_csg_gsg_cipublic-image/cipublic-image.js';
export class Header extends CipublicElement {
    constructor() {
        super(...arguments);
        this.hidenav = false;
        this.windowBackdrop = false;
        this.controller = new AbortController();
        this.i18n = new InternalI18n(this);
    }
    get sectionLinkHolder() {
        return this.querySelector('[slot="section-link"]');
    }
    get sectionNames() {
        var _a, _b;
        const sectionLinks = (_b = (_a = this.sectionLinkHolder) === null || _a === void 0 ? void 0 : _a.shadowRoot) === null || _b === void 0 ? void 0 : _b.querySelectorAll('[section-name]');
        if (!sectionLinks || !sectionLinks.length)
            return [];
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const allSections = new Set([...this.querySelectorAll('[section-name]'), ...sectionLinks]);
        return Array.from(allSections);
    }
    get isMobile() {
        return !window.matchMedia(`(min-width: ${gridBreakpoints.xl}px)`).matches;
    }
    static get styles() {
        return [styles];
    }
    async firstUpdated() {
        var _a, _b;
        await this.updateComplete;
        window.addEventListener('resize', debounce(() => {
            this.controller.abort();
            this.controller = new AbortController();
            if (this.mobileMenu)
                this.closeMobileMenu(undefined, false);
            this.requestUpdate();
        }, 250));
        if (this.mobileMenuBtn)
            (_b = (_a = this.mobileMenuBtn.shadowRoot) === null || _a === void 0 ? void 0 : _a.querySelector('button')) === null || _b === void 0 ? void 0 : _b.setAttribute('aria-expanded', 'false');
    }
    async updated(changedProperties) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o;
        super.updated(changedProperties);
        await this.updateComplete;
        const { signal } = this.controller;
        if (this.sectionLinkHolder && this.sectionLinkHolder.shadowRoot) {
            const listLinks = (_a = this.sectionLinkHolder.shadowRoot) === null || _a === void 0 ? void 0 : _a.querySelectorAll('[class="dropdown-content-items"] cipublic-list');
            addStyleSheetToElements(listLinks, listStyles);
            const headerContentBlocks = (_b = this.sectionLinkHolder.shadowRoot) === null || _b === void 0 ? void 0 : _b.querySelectorAll('[class="dropdown-content-items"] cipublic-content-block');
            addStyleSheetToElements(headerContentBlocks, headerContentBlockStyles);
            const dropdownSlots = (_c = this.sectionLinkHolder.shadowRoot) === null || _c === void 0 ? void 0 : _c.querySelectorAll('[id$="-menu"]');
            dropdownSlots.forEach((navMenu) => {
                navMenu.setAttribute('tabindex', '-1');
                navMenu.setAttribute('hidden', '');
            });
            addStyleSheetToElements(dropdownSlots, dropdownSlotsStyles);
            const dropdownHeading = (_d = this.sectionLinkHolder.shadowRoot) === null || _d === void 0 ? void 0 : _d.querySelectorAll('[id$="-menu"] [class="dropdown-heading"]');
            addStyleSheetToElements(dropdownHeading, dropdownHeadingStyles);
            const navigationLinks = this.findSlottedElements((_e = this.sectionLinkHolder.shadowRoot) === null || _e === void 0 ? void 0 : _e.querySelectorAll('*'), 'CIPUBLIC-LINK');
            addStyleSheetToElements(navigationLinks, navigationLinksStyles);
            addStyleSheetToElements([this.sectionLinkHolder], sectionLinkHolderStyles);
        }
        const mobileNavigationLinks = this.querySelectorAll('[slot="section-link-mobile"], [slot="section-link-mobile"] [slot="item"], [slot="mobile-current-section"]');
        addStyleSheetToElements(mobileNavigationLinks, mobileNavigationLinksStyles);
        const headerLogoLink = this.querySelectorAll('[slot^="header-logo"]');
        addStyleSheetToElements(headerLogoLink, headerLogoLinkStyles);
        const headerLogo = this.querySelectorAll('[slot^="header-logo"] cipublic-image');
        addStyleSheetToElements(headerLogo, headerLogoStyles);
        const headerLeftMenu = this.querySelectorAll('[slot="left-header-link"]');
        addStyleSheetToElements(headerLeftMenu, headerLeftMenuStyles);
        const headerLeftMenuLinks = (_g = (_f = this.querySelector('[slot="left-header-link"]')) === null || _f === void 0 ? void 0 : _f.shadowRoot) === null || _g === void 0 ? void 0 : _g.querySelectorAll('cipublic-link');
        addStyleSheetToElements(headerLeftMenuLinks, headerLeftMenuLinksStyles);
        const headerRightMenuLinksHolder = this.querySelectorAll('[slot="right-header-link"]');
        addStyleSheetToElements(headerRightMenuLinksHolder, headerRightMenuLinksHolderStyles);
        if (headerRightMenuLinksHolder.length) {
            const headerRightMenuLinks = this.findSlottedElements((_j = (_h = headerRightMenuLinksHolder[0]) === null || _h === void 0 ? void 0 : _h.shadowRoot) === null || _j === void 0 ? void 0 : _j.querySelectorAll('*'), 'CIPUBLIC');
            const languageToggleLink = ((_l = (_k = headerRightMenuLinks
                .find((element) => element.tagName.includes('LANGUAGE'))) === null || _k === void 0 ? void 0 : _k.shadowRoot) === null || _l === void 0 ? void 0 : _l.querySelectorAll('cipublic-link')) || [];
            addStyleSheetToElements([...headerRightMenuLinks, ...languageToggleLink], headerRightMenuLinksStyles);
        }
        const mobileMenuLinksHolder = [];
        const getMobileMenuLinks = () => {
            this.querySelectorAll('cipublic-list[slot="content"]').forEach((element) => { var _a; return (_a = element.shadowRoot) === null || _a === void 0 ? void 0 : _a.querySelectorAll('cipublic-link').forEach((link) => mobileMenuLinksHolder.push(link)); });
        };
        getMobileMenuLinks();
        addStyleSheetToElements(mobileMenuLinksHolder, mobileMenuLinksStyles);
        const mobileButtonToggle = this.renderRoot.querySelectorAll('.menu-toggle-button');
        addStyleSheetToElements(mobileButtonToggle, mobileMenuToggleStyles);
        if (!this.isMobile) {
            // @ts-ignore next-line
            this.focusTrap.trapDisabled = true;
            const dropdownContents = [];
            const sectionLink = this.findSlottedElements((_o = (_m = this.sectionLinkHolder) === null || _m === void 0 ? void 0 : _m.shadowRoot) === null || _o === void 0 ? void 0 : _o.querySelectorAll('*'), 'CIPUBLIC-LINK');
            Array.from(sectionLink).forEach((element) => {
                const dropdownMenu = element.nextElementSibling;
                if (dropdownMenu) {
                    dropdownMenu.classList.remove('open');
                    const dropdownContent = dropdownMenu.querySelector('[id$="-menu"');
                    dropdownContents.push(dropdownContent);
                    element.addEventListener('focus', () => {
                        this.closeNavigationMenu();
                    }, { signal });
                    element.addEventListener('mouseenter', (evt) => {
                        this.openNavigationMenu(dropdownMenu, dropdownContent, evt.target);
                    }, { signal });
                    element.addEventListener('keydown', (evt) => {
                        if (evt.key !== 'Enter' && evt.key !== 'Escape' && evt.key !== 'Tab' && !evt.shiftKey && evt.key !== ' ')
                            return;
                        if (evt.key === 'Enter' || evt.key === ' ') {
                            evt.preventDefault();
                            if (element.classList.contains('active')) {
                                this.closeNavigationMenu();
                            }
                            else {
                                this.openNavigationMenu(dropdownMenu, dropdownContent, evt.target);
                            }
                        }
                        else if (evt.key === 'Escape') {
                            evt.preventDefault();
                            if (element.classList.contains('active')) {
                                this.closeNavigationMenu();
                            }
                            else {
                                return;
                            }
                        }
                        else if (element.classList.contains('active')) {
                            evt.preventDefault();
                            // @ts-ignore next-line
                            this.focusTrap.firstFocusElement.focus();
                        }
                    }, { signal });
                    dropdownMenu.addEventListener('mouseleave', () => {
                        this.closeNavigationMenu();
                    }, { signal });
                    dropdownContent.addEventListener('keydown', (evt) => {
                        var _a, _b;
                        if (evt.key !== 'Escape' && evt.key !== 'Tab')
                            return;
                        if (evt.key === 'Escape') {
                            evt.preventDefault();
                            (_b = (_a = element.shadowRoot) === null || _a === void 0 ? void 0 : _a.querySelector('button')) === null || _b === void 0 ? void 0 : _b.focus();
                            this.closeNavigationMenu();
                        }
                        else if (
                        // @ts-ignore next-line
                        evt.composedPath()[0] === this.focusTrap.lastFocusElement &&
                            dropdownContent === dropdownContents[dropdownContents.length - 1]) {
                            this.closeNavigationMenu();
                        }
                    }, { signal });
                }
            });
        }
        else {
            let startOfTouch = 0;
            let endOfTouch = 0;
            this.mobileMenu.addEventListener('keydown', (evt) => {
                if (evt.key !== 'Escape' || !this.mobileMenu.classList.contains('open'))
                    return;
                evt.preventDefault();
                evt.stopImmediatePropagation();
                this.closeMobileMenu();
            }, { signal });
            this.mobileMenu.addEventListener('touchstart', (evt) => {
                startOfTouch = evt.changedTouches[0].screenX;
            });
            this.mobileMenu.addEventListener('touchend', (evt) => {
                endOfTouch = evt.changedTouches[0].screenX;
                this.handleMenuClose(startOfTouch, endOfTouch);
            });
            window.addEventListener('backdrop.closed', this.checkIfMenuClosed.bind(this), { signal });
        }
        window.addEventListener('search-opened', this.toggleSearch.bind(this), { signal });
        window.addEventListener('search-closed', this.toggleSearch.bind(this), { signal });
        this.setActiveSection();
    }
    setActiveSection() {
        let allMatchingSections = [];
        const pathSections = location.pathname
            .split('/')
            .filter((pth) => pth.length)
            .reverse();
        pathSections.every((section) => {
            allMatchingSections = this.sectionNames.filter((element) => element.getAttribute('section-name') === section.replace('.html', ''));
            if (allMatchingSections.length) {
                return false;
            }
            return true;
        });
        if (allMatchingSections && allMatchingSections.length > 0) {
            allMatchingSections.forEach((section) => {
                var _a;
                const sectionButton = (_a = section.shadowRoot) === null || _a === void 0 ? void 0 : _a.querySelector('button, a');
                section.setAttribute('iscurrentsection', '');
                sectionButton.setAttribute('aria-current', 'true');
            });
        }
    }
    handleMenuClose(startOfTouch, endOfTouch) {
        if (endOfTouch < startOfTouch && startOfTouch - endOfTouch > 150)
            this.checkIfMenuClosed();
    }
    checkIfMenuClosed() {
        if (this.mobileMenu && this.mobileMenu.classList.contains('open'))
            this.closeMobileMenu();
    }
    openMobileMenu() {
        var _a, _b;
        const mobileMenuButton = (_a = this.mobileMenuBtn.shadowRoot) === null || _a === void 0 ? void 0 : _a.querySelector('button');
        (_b = this.mobileMenu) === null || _b === void 0 ? void 0 : _b.classList.add('open');
        this.focusTrap.setAttribute('trapped', '');
        this.mobileMenu.classList.remove('hidden');
        this.windowBackdrop = true;
        mobileMenuButton === null || mobileMenuButton === void 0 ? void 0 : mobileMenuButton.setAttribute('aria-expanded', 'true');
        // @ts-ignore next-line
        this.focusTrap.firstFocusElement.focus();
    }
    closeMobileMenu(_event, isEvent = true) {
        var _a, _b;
        if (!this.mobileMenu.classList.contains('open'))
            return;
        const mobileMenuButton = (_a = this.mobileMenuBtn.shadowRoot) === null || _a === void 0 ? void 0 : _a.querySelector('button');
        (_b = this.mobileMenu) === null || _b === void 0 ? void 0 : _b.classList.remove('open');
        this.focusTrap.removeAttribute('trapped');
        this.mobileMenu.classList.add('hidden');
        this.windowBackdrop = false;
        mobileMenuButton === null || mobileMenuButton === void 0 ? void 0 : mobileMenuButton.setAttribute('aria-expanded', 'false');
        if (isEvent)
            mobileMenuButton === null || mobileMenuButton === void 0 ? void 0 : mobileMenuButton.focus();
    }
    findSlottedElements(list, filter) {
        if (!list || !list.length)
            return [];
        return [...list].filter((element) => { var _a; return element.nodeName.includes(filter) && !((_a = element.parentNode) === null || _a === void 0 ? void 0 : _a.nodeName.includes('CONTENT-BLOCK')); });
    }
    openNavigationMenu(dropdownMenu, dropdownContent, target) {
        var _a, _b;
        this.closeNavigationMenu();
        target.classList.add('active');
        (_b = (_a = target.shadowRoot) === null || _a === void 0 ? void 0 : _a.querySelector('button')) === null || _b === void 0 ? void 0 : _b.setAttribute('aria-expanded', 'true');
        dropdownContent.removeAttribute('tabindex');
        dropdownContent.removeAttribute('hidden');
        dropdownContent.classList.add('open');
        dropdownMenu === null || dropdownMenu === void 0 ? void 0 : dropdownMenu.classList.add('open');
        this.focusTrap.setAttribute('trapped', '');
    }
    closeNavigationMenu() {
        var _a, _b;
        this.focusTrap.removeAttribute('trapped');
        const sectionLink = this.findSlottedElements((_b = (_a = this.sectionLinkHolder) === null || _a === void 0 ? void 0 : _a.shadowRoot) === null || _b === void 0 ? void 0 : _b.querySelectorAll('*'), 'CIPUBLIC-LINK');
        Array.from(sectionLink).forEach((element) => {
            var _a, _b;
            const dropdownMenu = element.nextElementSibling;
            if (dropdownMenu) {
                const dropdownContent = dropdownMenu.querySelector('[id$="-menu"');
                element.classList.remove('active');
                (_b = (_a = element.shadowRoot) === null || _a === void 0 ? void 0 : _a.querySelector('button')) === null || _b === void 0 ? void 0 : _b.setAttribute('aria-expanded', 'false');
                dropdownContent.setAttribute('tabindex', '-1');
                dropdownContent.setAttribute('hidden', '');
                dropdownContent.classList.remove('open');
                dropdownMenu.classList.remove('open');
            }
        });
    }
    toggleSearch(action) {
        const headerMenuLinksHolder = this.querySelectorAll('[slot$="-header-link"]');
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const allHeaderSlots = [];
        headerMenuLinksHolder.forEach((element) => {
            var _a, _b;
            [...(_a = element === null || element === void 0 ? void 0 : element.shadowRoot) === null || _a === void 0 ? void 0 : _a.querySelectorAll('*')]
                .filter((element) => element.nodeName.includes('CIPUBLIC') || element.classList.contains('left-link-wrap'))
                .filter((element) => !element.nodeName.includes('SEARCH'))
                .forEach((link) => allHeaderSlots.push(link));
            Array.from((_b = element.shadowRoot) === null || _b === void 0 ? void 0 : _b.querySelectorAll('li'))
                .filter((element) => { var _a; return ((_a = element.firstElementChild) === null || _a === void 0 ? void 0 : _a.tagName) === 'CIPUBLIC-HEADER-SEARCH'; })
                .forEach((element) => element.classList.add('list-search-holder'));
        });
        const searchOpened = action.type === 'search-opened';
        this.classList.toggle('search-active', searchOpened);
        this.windowBackdrop = searchOpened;
        [].forEach.call(allHeaderSlots, (element) => element.toggleAttribute('hidden', searchOpened));
    }
    render() {
        if (this.isMobile)
            return html `<header><div class="header-links-container"><slot name="header-logo"></slot><div class="right-wrapper"><slot name="right-header-link"></slot></div></div></header><div class="mobile-navigation"><cipublic-link href="#" isbutton="" class="menu-toggle-button menu-open-button" @click="${this.openMobileMenu}"><cipublic-icon set="system" name="bars" slot="prefix"></cipublic-icon>${this.i18n.t('menu')}</cipublic-link><slot name="login-button"></slot></div><cipublic-focus-trap><div class="mobile-menu-wrapper hidden"><div class="logo-wrapper"><slot name="header-logo-mobile"></slot><cipublic-close-button class="menu-toggle-button menu-close-button" @click="${this.closeMobileMenu}"></cipublic-close-button></div><nav aria-label="section"><slot name="mobile-current-section" class="current-section"></slot><slot name="section-link-mobile"></slot></nav><nav class="header-links" aria-label="main" id="cipublic-header"><slot name="left-header-link"></slot></nav></div></cipublic-focus-trap><cipublic-backdrop ?active="${this.windowBackdrop}" @click="${this.closeMobileMenu}"></cipublic-backdrop>`;
        else
            return html `<header><div class="container header-links-container"><slot name="header-logo"></slot><nav class="header-links" aria-label="main" id="cipublic-header"><slot name="left-header-link"></slot><div class="header-links-pipe"> </div><slot name="right-header-link"></slot></nav></div></header><nav class="navigation" aria-label="section"><div class="container"><div class="page-links"><slot name="current-section" class="current-section"></slot><cipublic-focus-trap><slot name="section-link"></slot></cipublic-focus-trap></div><slot name="login-button"></slot></div></nav><cipublic-backdrop ?active="${this.windowBackdrop}"></cipublic-backdrop>`;
    }
}
__decorate([
    property({ type: Boolean })
], Header.prototype, "hidenav", void 0);
__decorate([
    state()
], Header.prototype, "isMobile", null);
__decorate([
    state()
], Header.prototype, "windowBackdrop", void 0);
__decorate([
    query('.mobile-menu-wrapper')
], Header.prototype, "mobileMenu", void 0);
__decorate([
    query('cipublic-focus-trap')
], Header.prototype, "focusTrap", void 0);
__decorate([
    query('.menu-open-button')
], Header.prototype, "mobileMenuBtn", void 0);
__decorate([
    state()
], Header.prototype, "controller", void 0);
//# sourceMappingURL=header.js.map